import DefaultLayout from '@/Layouts/DefaultLayout';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginRoutes } from '@/features/auth/routes/routes';
import { AuthInitializer } from '@/features/auth/guard/authInitializer';
import { CustomerRealtionsRoutes } from '@/features/customerRelations/routes/routes';
import { OrderListRoutes } from '@/features/orders/routes/routes';
import { ServiceListRoutes } from '@/features/services/routes/routes';
import { HumanResourcesRoutes } from '@/features/humanResources/routes/routes';
import { BranchesRoutes } from '@/features/branch/routes/routes';
import { SettingRoutes } from '@/features/setting/routes/routes';
import { PermissionsRoutes } from '@/features/permissions/routes/routes';
import { ReportsRoutes } from '@/features/reports/routes/routes';
import { ProductsListRoutes } from '@/features/products/routes/routes';
import { SubscriptionsRoutes } from '@/features/subscriptions/routes/routes';
import { FinanceRoutes } from '@/features/finance/routes/routes';
import { NotificationsRoutes } from '@/features/notifications/routes/routes';
import { CustomerByTypeRoutes } from '@/features/customers_by_type/routes/routes';

// ----------------------------------------------------------------------

const Home = lazy(() => import('@/core/global-pages/Home'));
const SoonPage = lazy(() => import('@/core/global-pages/SoonPage'));

// ----------------------------------------------------------------------

const appChildren = [
    { index: true, element: <Home /> },
    {
        path: '/coming-soon',
        element: <SoonPage />,
        layout: 'default',
        isAuthReq: true,
    },

    ...CustomerRealtionsRoutes,
    ...OrderListRoutes,
    ...ServiceListRoutes,
    ...HumanResourcesRoutes,
    ...BranchesRoutes,
    ...SettingRoutes,
    ...PermissionsRoutes,
    ...ReportsRoutes,
    ...ProductsListRoutes,
    ...SubscriptionsRoutes,
    ...FinanceRoutes,
    ...NotificationsRoutes,
    ...CustomerByTypeRoutes,
];

// Normalize child paths for language-prefixed parent.
// When nesting under '/:lang', child routes must be relative (no leading '/').
const normalizeChildPaths = (routesArray: any[]): any[] => {
    return routesArray.map((route) => {
        const r = { ...route } as any;
        if (typeof r.path === 'string' && r.path.startsWith('/')) {
            r.path = r.path.replace(/^\//, '');
        }
        if (Array.isArray(r.children) && r.children.length) {
            r.children = normalizeChildPaths(r.children);
        }
        return r;
    });
};

const routes = [
    // language-prefixed routes: /ar/... or /en/...
    {
        path: '/:lang',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        children: normalizeChildPaths(appChildren),
    },

    // root routes (no prefix) - keep existing structure for backward compatibility
    {
        path: '/',
        element: (
            <AuthInitializer>
                <DefaultLayout />
            </AuthInitializer>
        ),
        children: appChildren,
    },

    // login and auth routes (remain at top-level)
    ...LoginRoutes,
];
export { routes };
